var loading = {
	/**
	 * Initializes loading behavior for forms with data-loading-message attribute
	 *
	 * Finds all forms with data-loading-message attribute within the target element
	 * and sets up loading behavior for each form. The loading behavior shows a modal
	 * with a loading message when the form is submitted.
	 *
	 * @param {HTMLElement} [target=document.body] - The root element to search for forms
	 *
	 * @returns {void}
	 */
	init: function(target = document.body) {
		target.querySelectorAll('form[data-loading-message]').forEach(form => {
			this.handleFormLoadingBehavior(form);
		});
	},

	/**
	 * Handles the loading behavior for a form
	 * Shows a loading modal when the form is submitted or validation succeeds
	 *
	 * @param {HTMLFormElement} form - The form element to handle loading behavior for
	 *
	 * @returns {void}
	 */
	handleFormLoadingBehavior: function(form) {
		const loadingMessage = form.getAttribute('data-loading-message');
		if (form.hasAttribute('data-loading-message')) {
			document.addEventListener('validationSuccess', () => {
				loading.showLoadingModal(loadingMessage);
			});
		} else {
			form.addEventListener('submit', (event) => {
				setTimeout(() => {
					if (!event.defaultPrevented) {
						loading.showLoadingModal(loadingMessage);
					}
				}, 500);
			});
		}
	},

	/**
	 * Shows a loading modal with a custom message
	 *
	 * Creates and displays a Bootstrap modal that cannot be dismissed by the user.
	 * The modal shows a loading message and prevents interaction with the page
	 * while an action is being processed.
	 *
	 * @param {string} loadingMessage - The message to display in the loading modal
	 *
	 * @returns {void}
	 */
	showLoadingModal: function(loadingMessage) {
		document.getElementById('loadingMessageModal').innerHTML = loadingMessage;
		var loadingModal = document.getElementById('loadingModal');
		var bootstrapModal = new bootstrap.Modal(loadingModal, {
			keyboard: false,
			backdrop: 'static'
		});
		bootstrapModal.show();
	}
};

export default loading;
